import React from 'react';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageOptionType } from '@app/component/tabs/PageTabs';
import Utilities from '@util/Utilities';

const FragmentButtonTabs: React.FunctionComponent<{options: PageOptionType[]}> = ({ options}) => {

	const activeClassNames = 'relative inline-flex items-center justify-center w-1/3 gap-x-1.5 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 ring-1 ring-inset ring-gray-300 pointer-events-none';
	const inactiveClassNames = 'relative -ml-px inline-flex items-center justify-center w-1/3 gap-x-1.5 bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10';
	const disabledClassNames = 'relative -ml-px inline-flex items-center justify-center w-1/3 gap-x-1.5 bg-gray-50 px-3 py-2 text-sm font-semibold text-gray-300 ring-1 ring-inset ring-gray-300 cursor-not-allowed';

	const firstOptionClassNames = 'rounded-l-md';
	const lastOptionClassNames = 'rounded-r-md';

	const location = useLocation();
	const navigate = useNavigate();

	const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		navigate(event.target.value);
	};

	const isTabActive = (url: string, isRouter = false) => {
		return !!matchPath(url + (isRouter ? '/*' : ''), location.pathname);
	};

	return <>
		<div className="mb-5">
			<div className="grid grid-cols-1 sm:hidden">
				<select aria-label="Select a tab"
								value={location.pathname}
								onChange={handleSelectChange}
								className="col-start-1 row-start-1 w-full input">
					{options.map(o => <option key={o.label} id={o.label} value={o.link} disabled={o.disabled}>{o.label}</option>)}
				</select>
			</div>
			<div className="hidden sm:block">
				<div className="isolate inline-flex w-full">
					{options.map((o, i) => <button key={o.label}
																		onClick={() => navigate(o.link)}
																		disabled={o.disabled}
																		className={Utilities.classNames(o.disabled ? disabledClassNames : isTabActive(o.match || o.link, o.isRouter) ? activeClassNames : inactiveClassNames, i==0 ? firstOptionClassNames : i==options.length-1 ? lastOptionClassNames : '', 'shadow-sm')}>
						{!!o.icon && o.icon}
						<span>{o.label}</span>
					</button>)}
				</div>
			</div>
		</div>
		{options.find(o => isTabActive(o.link, o.isRouter))?.fragment}
	</>;
};

export default FragmentButtonTabs;
